/**
 * VuePrint v1.6.3
 * Copyright (c) 2024 Jak Guru LLC
 * Vueprint a commerical work product released under the MIT License
 * and is provided as-is with no warranty or guarantee of support.
 * Documentation: https://jakguru.github.io/vueprint/
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import axios from 'axios';
import { L as LocalStorageService } from './vueprint.19cdf2cc.mjs';
import { B as BusService } from './vueprint.1f7141fe.mjs';

const initializeApi = (baseURL, ls, bus) => {
  if (!(ls instanceof LocalStorageService)) {
    throw new Error("Invalid or missing LocalStorageService instance");
  }
  if (!(bus instanceof BusService)) {
    throw new Error("Invalid or missing Bus instance");
  }
  const instance = axios.create({
    baseURL,
    headers: {
      "Content-Type": "application/json"
    },
    validateStatus: () => true
  });
  instance.interceptors.request.use(
    (config) => {
      if (ls && ls.loaded) {
        const bearer = ls.get("bearer");
        if (bearer) {
          config.headers.Authorization = `Bearer ${bearer}`;
        }
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  instance.interceptors.response.use(
    (response) => {
      if (response.status === 401) {
        if (bus) {
          bus.emit("api:unauthorized", {
            local: true,
            crossTab: true
          });
        }
      }
      return response;
    },
    (error) => {
      if (error.response && error.response.status === 401) {
        if (bus) {
          bus.emit("api:unauthorized", {
            local: true,
            crossTab: true
          });
        }
      }
      return Promise.reject(error);
    }
  );
  return instance;
};
const isAxiosInstance = (instance) => {
  return "function" === typeof instance && "object" === typeof instance.defaults && "function" === typeof instance.request && "function" === typeof instance.get && "function" === typeof instance.delete && "function" === typeof instance.head && "function" === typeof instance.options && "function" === typeof instance.post && "function" === typeof instance.put && "function" === typeof instance.patch;
};

const api = {
  __proto__: null,
  initializeApi: initializeApi,
  isAxiosInstance: isAxiosInstance
};

export { api as a, initializeApi as b, isAxiosInstance as i };
//# sourceMappingURL=vueprint.fd68f7a1.mjs.map
